import { Breadcrumb } from '@/components/Atoms/Breadcrumbs'
import Container from '@/components/Atoms/Container'
import Loading from '@/components/Atoms/Loading'
import { Header } from '@/components/ui/header'
import { buildPath, Params } from '@/routes'
import { Suspense, useCallback } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router'
import { LicensingAgencyProvider } from '../hooks/licensing-agency-provider'
import { LicensingAgencyStepGuard } from './LicensingAgencyStepGuard'
import { LicensingAgencySteps } from './LicensingAgencySteps'
import { HasFeature } from '@/components/Atoms/Permissions'
import { LicensingAgentsFeature } from '@/lib/features'

export function LicensingAgencyApplicationLayout() {
  // Hooks
  const navigate = useNavigate()
  const { agencyId } =
    useParams<
      Params<'/applications/licensing-agency/:agencyId/business-info'>
    >()

  const onNotFound = useCallback(() => {
    navigate(buildPath('/applications/licensing-agency'))
  }, [navigate])

  // Agency ID is not in URL (not possible, but check for type-safety)
  if (!agencyId)
    return <Navigate to={buildPath('/applications/licensing-agency')} />

  return (
    <HasFeature
      feature={LicensingAgentsFeature.Application}
      noFeatureComponent={<Navigate to={buildPath('/applications')} />}
    >
      <Container className="mt-2 flex flex-col gap-4">
        <Breadcrumb
          label="Licensing Agency"
          path={buildPath('/applications/licensing-agency')}
        />

        <div className="mx-4 flex flex-col gap-6">
          <Header variant="h1">Licensing Agency</Header>

          <LicensingAgencyProvider agencyId={agencyId} onNotFound={onNotFound}>
            <LicensingAgencySteps agencyId={agencyId}>
              <Suspense
                fallback={<Loading variant="fullscreen" className="min-h-64" />}
              >
                {/* Includes the outlet */}
                <LicensingAgencyStepGuard />
              </Suspense>
            </LicensingAgencySteps>
          </LicensingAgencyProvider>
        </div>
      </Container>
    </HasFeature>
  )
}
